const PCR = {
	banner: [{
		tips:'什么是PCR？',
		title:'PCR',
		content:'PCR指产品种类规则（Product-Category Rules），是对一个或多个产品种类进行Ⅲ型环境声明（即EPD）所必须满足的一套具体的规则、要求和指南。',
		img:require('@/assets/img/index/PCR_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	}],
	seach:'搜索已公告的PCR'
}

export default PCR